import React from 'react';
import { Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { StyledDialogTitle } from '../../styled/Dialog/StyledDialogTitle';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useCart from '../../../hooks/cart/useCart';
import useQuotationActionsDialog from '../../../hooks/dialogs/useQuotationActionsDialog';
import CreateNewMyQuotation from './CreateNewMyQuotation';
import AddToExistQuotation from './AddToExistQuotation';
import CreateOrderTemplate from './CreateOrderTemplate';
import CreateNewQuotation from './CreateNewQuotation';

const QuotationDialog = () => {
    const quotationActionsDialog = useQuotationActionsDialog();
    const navigate = useNavigate();
    const cart = useCart();
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATION_DIALOG',
    });

    const closeConfirmDialog = () => {
        quotationActionsDialog.closeDialog();
    };

    const handleSuccessClose = (quotationId: number) => {
        quotationActionsDialog.closeDialog();
        cart.resetCart(quotationActionsDialog.dialog.products);
        if (quotationActionsDialog.dialog.type == 'add') {
            navigate('/quotation/edit/' + quotationId);
        } else {
            navigate('/my-quotations/' + quotationId);
        }
    };

    const handleCartSave = () => {
        cart.resetCart(quotationActionsDialog.dialog.products);
        quotationActionsDialog.closeDialog();
    };

    return (
        <Dialog
            open={quotationActionsDialog.dialog.open}
            onClose={closeConfirmDialog}
            maxWidth={'sm'}
            fullWidth
        >
            <StyledDialogTitle>
                {t(quotationActionsDialog.dialog.dialogTitle)}
                <CloseIcon
                    sx={{ cursor: 'pointer' }}
                    onClick={closeConfirmDialog}
                />
            </StyledDialogTitle>
            {quotationActionsDialog.dialog.dialogType == 'createNew' &&
                quotationActionsDialog.dialog.type == 'request' && (
                    <CreateNewMyQuotation
                        products={quotationActionsDialog.dialog.products}
                        handleSave={(quotationId) =>
                            handleSuccessClose(quotationId)
                        }
                    />
                )}
            {quotationActionsDialog.dialog.dialogType == 'createNew' &&
                quotationActionsDialog.dialog.type == 'add' && (
                    <CreateNewQuotation
                        products={quotationActionsDialog.dialog.products}
                        handleSave={(quotationId) =>
                            handleSuccessClose(quotationId)
                        }
                    />
                )}
            {quotationActionsDialog.dialog.dialogType == 'addExist' && (
                <AddToExistQuotation
                    products={quotationActionsDialog.dialog.products}
                    handleSave={(quotationId) =>
                        handleSuccessClose(quotationId)
                    }
                />
            )}
            {quotationActionsDialog.dialog.dialogType == 'saveCart' && (
                <CreateOrderTemplate
                    products={quotationActionsDialog.dialog.products}
                    handleSave={handleCartSave}
                />
            )}
        </Dialog>
    );
};

export default QuotationDialog;
